module.exports = __webpack_public_path__ + "static/media/contenedores-02.f374163b.png";